import React from 'react';

import IntermediatePage from '../components/IntermediatePage';
import PrivacyPolicy from 'pages/home/components/contact/PrivacyPolicy';

const Privacidade = () => {
    return (
        <IntermediatePage
            helmetTitle="Política de Privacidade"
            helmetMetaDescription="Política de Privacidade da Plataforma humane do Instituto Ayrton Senna."
            title1=""
            title2="Política de Privacidade"
            highlightedBanner
        >
            <PrivacyPolicy />
        </IntermediatePage>
    );
};

export default Privacidade;
